const constant = {
  rosterList: [
    { key: "full", label: "全日更", value: "full" },
    { key: "a", label: "A更", value: "a" },
    { key: "b", label: "B更", value: "b" },
  ],
  productType: {
    mannings: "萬寧",
    staff_purchase: "員工購物",
  },
  redeemMethods: {
    hidden_offer: "Hidden Offer",
    pharmagood: "PharmaGood",
  },
  regionType: {
    1: "香港",
    2: "澳門",
  },
  brand: {
    3: "germany",
    17: "inne",
    4: "holdbody",
    5: "jinTan",
    7: "proteca",
    10: "proVen",
    8: "return",
    9: "shaoYeh",
    16: "spatone",
  },
  expensesCategory: [
    "Branding",
    "Online Branding",
    "Printing",
    "Outdoor Ad",
    "Newspaper",
    "Manning POP",
    "KOL",
    "Online Media Page",
    "Social Media",
    "Keyword Search",
    "Others",
  ],
  boxValue: [
    { type: "please select", display: "請選擇" },
    { type: "textField", display: "文字" },
    { type: "dropDown", display: "下拉式選單（單選）" },
    { type: "checkBox", display: "勾選方格（多選）" },
    { type: "uploadFile", display: "上載相片" },
    { type: "dropDownWithProduct", display: "下拉式選單（產品）" },
  ],
};

export default constant;
